module.exports = __webpack_public_path__ + "img/20200224_181329.7794b398.jpg";